/*
 * @Author: zhaofy
 * @Date: 2018-03-07 00:17:43
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-07-Sa 09:40:59
 */
<template>
  <!-- 新建地址弹框页面 -->
  <div>
    <Modal
      v-model="isShow"
      class="address-modal"
      @on-cancel="cancel"
      width="550"
    >
      <p
        slot="header"
        style="color:#3280bf;text-align:center"
      >
        <span>新增收货人地址</span>
      </p>
      <div>
        <Form
          :model="addForm"
          :label-width="120"
          style="background-color:#fff;padding-bottom: 20px;"
        >
          <FormItem
            label="姓名"
            class="must"
          >
            <Input
              v-model="addForm.consigneeName"
              class="form-input"
            ></Input>
            <label style="padding-left:15px;">请填写真实姓名，以免延误收货</label>
          </FormItem>
          <FormItem
            label="手机"
            class="must"
          >
            <Input
              v-model="addForm.mobile"
              class="form-input"
            ></Input>
          </FormItem>
          <FormItem label="电话">
            <Input
              v-model="addForm.telephone"
              class="form-input"
            ></Input>
            <label style="padding-left:15px;">手机和电话填写一项即可</label>
          </FormItem>
          <FormItem
            label="地区"
            class="must"
          >
            <Select
              v-model="addForm.provinceId"
              @on-change="getCityList"
              size="small"
              placeholder="请选择省份"
              style="width:100px"
            >
              <Option
                v-for="item in provinceList"
                :value="item.regionId"
                :key="item.regionId"
              >{{ item.localName
                          }}
              </Option>
            </Select>
            <Select
              v-model="addForm.cityId"
              size="small"
              @on-change="getRegionList"
              style="width:100px"
            >
              <Option
                v-for="item in cityList"
                :value="item.regionId"
                :key="item.regionId"
              >{{ item.localName }}
              </Option>
            </Select>
            <!-- @on-change="getCountryList" -->
            <Select
              v-model="addForm.regionId"
              size="small"
              style="width:100px"
              @on-change="getCountryList"
            >
              <Option
                v-for="item in regionList"
                :value="item.regionId"
                :key="item.regionId"
              >{{ item.localName
                          }}
              </Option>
            </Select>
            <Select
              v-model="addForm.countyId"
              size="small"
              style="width:100px"
            >
              <Option
                v-for="item in countryList"
                :value="item.regionId"
                :key="item.regionId"
              >{{ item.localName
                          }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="地址"
            class="must"
          >
            <Input
              v-model="addForm.address"
              class="form-input"
            ></Input>
          </FormItem>
          <FormItem label="邮编">
            <Input
              v-model="addForm.zipCode"
              class="form-input"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <!-- <div style="text-align:center">
                <p>After this task is deleted, the downstream 10 tasks will not be implemented.</p>
                <p>Will you delete it?</p>
            </div> -->
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="saveAddr"
        >保存并返回</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getAddressInfo, addressAdd, getAddressTowns } from "api/user";
import { getSession } from "utils/tool";
export default {
  name: "addressModal",
  props: {
    isShowAddreModal: [Boolean],
    getAddressList: [Function],
  },
  data() {
    return {
      isShow: this.isShowAddreModal,
      addForm: {
        addressId: "", // 收货地址id
        defaultAddress: 0, // 是否默认收货地址
        telephone: "", // 电话
        mobile: "", // 电话
        provinceId: "", // 省id
        cityId: "", // 市id
        regionId: "", // 区域id
        countyId: "",
        province: "", // 省
        city: "", // 市
        region: "", // 	区域
        countyName: "",
        address: "", // 地址
        zipCode: "", // 邮编
        consigneeName: "", // 用户名称
      },
      addressAll: {}, //保存全部数据
      provinceList: [], //省
      cityList: [], //市
      regionList: [], //区
      countryList: [], // 乡镇
    };
  },
  created() {
    if (localStorage.getItem("townList")) {
      this.addressAll = JSON.parse(localStorage.getItem("townList")).data;
      this.provinceList = JSON.parse(
        localStorage.getItem("townList")
      ).data.provinceList;
    } else {
      this.getProvinceList();
    }
  },
  mounted() {
    // 获取省列表
    // this.getProvinceList();
  },
  watch: {
    isShowAddreModal() {
      this.isShow = this.isShowAddreModal;
    },
  },
  methods: {
    // 获取街道
    getAddressTowns(parentId) {
      getAddressTowns({ parentId: parentId }).then((res) => {
        this.countryList = res.data;
      });
    },
    // 获取省列表
    getProvinceList() {
      getAddressInfo().then((resp) => {
        this.addressAll = resp.data;
        this.provinceList = resp.data.provinceList;
      });
    },
    // 根据省ID获取市列表
    getCityList(item) {
      if (!item) return;
      this.cityList = this.addressAll.cityList.filter(
        (v) => v.parentRegionId == item
      );
      this.addForm.cityId = "";
      this.addForm.regionId = "";
      this.addForm.countyId = "";
    },
    // 根据市ID获取区列表
    getRegionList(item) {
      if (!item) return;
      this.regionList = this.addressAll.areaList.filter(
        (v) => v.parentRegionId == item
      );
      this.addForm.regionId = "";
      this.addForm.countyId = "";
    },
    // 根据区县ID获取乡镇列表
    getCountryList(item) {
      if (!item) return;
      this.getAddressTowns(item);
    },
    toggleTab(name) {
      this.tabIndex = name;
      if (name === "list") {
        this.addrTitle = "新增收货地址";
        this.setAddrData("");
      }
    },
    // 修改表单数据
    setAddrData(data) {
      if (data === "") {
        this.resetAdd();
      } else {
        this.addForm = data;
      }
    },
    resetAdd() {
      this.addForm = {
        addressId: "", // 收货地址id
        defaultAddress: 0, // 是否默认收货地址
        telephone: "", // 电话
        mobile: "", // 电话
        provinceId: "", // 省id
        cityId: "", // 市id
        regionId: "", // 区域id
        countyId: "",
        province: "", // 省
        city: "", // 市
        region: "", // 	区域
        countyName: "",
        address: "", // 地址
        zipCode: "", // 邮编
        consigneeName: "", // 用户名称
      };
    },
    cancel() {
      this.resetAdd();
      this.$emit("update:isShowAddreModal", false);
    },
    // 保存地址
    saveAddr() {
      if (this.addForm.consigneeName.trim().length === 0) {
        this.$Message.warning("姓名不能为空");
        return;
      }
      if (
        this.addForm.telephone.trim().length === 0 &&
        this.addForm.mobile.trim().length === 0
      ) {
        this.$Message.warning("联系电话和联系手机必须填写一项!");
        return;
      }
      if (this.addForm.mobile.trim().length > 0) {
        // 验证手机号码
        const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.addForm.mobile)) {
          this.$Message.warning("手机格式不正确!");
          return;
        }
      }
      if (this.addForm.telephone.trim().length > 0) {
        // 验证联系电话
        if (
          !/^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(
            this.addForm.telephone
          )
        ) {
          this.$Message.warning("联系电话格式不正确!");
          return;
        }
      }
      if (
        this.addForm.provinceId.length === 0 ||
        this.addForm.cityId.length === 0 ||
        this.addForm.regionId.length === 0 ||
        this.addForm.countyId.length === 0
      ) {
        this.$Message.warning("地区选择不能为空!");
        return;
      }
      if (this.addForm.address.trim().length === 0) {
        this.$Message.warning("地址不能为空");
        return;
      }
      let params = {
        ...this.addForm,
      };
      params.province = this.provinceList.filter(
        (i) => i.regionId === this.addForm.provinceId
      )[0].localName;
      params.city = this.cityList.filter(
        (i) => i.regionId === this.addForm.cityId
      )[0].localName;
      params.region = this.regionList.filter(
        (i) => i.regionId === this.addForm.regionId
      )[0].localName;

      params.countyName = this.countryList.filter(
        (i) => i.regionId === this.addForm.countyId
      )[0].localName;

      addressAdd(params).then((resp) => {
        if (resp.resCode === 1) {
          this.$Modal.success({
            content: "新增地址成功!",
            onOk: () => {
              this.$emit("update:isShowAddreModal", false);
              this.getAddressList();
              this.resetAdd();
              // this.$router.go(0);
            },
          });
        } else {
          this.$Message.error(resp.resDesc);
        }
      });
    },
  },
};
</script>
<style lang="less">
.address-modal {
  .box > .ivu-tabs > .ivu-tabs-bar {
    margin-bottom: 0 !important;
    border-bottom: none;
  }

  .box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    color: #000;
    font-size: 12px;
    background: #eeeeee;
  }

  .box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
    background: #fff;
  }

  .box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav:first-child {
    margin-left: 22px;
  }

  .box > .ivu-card-bordered {
    border-top: none;
  }

  .ivu-btn-text {
    color: #53a0be !important;
  }

  .ivu-btn-text:hover {
    color: #e4393c !important;
  }
  .form-input {
    width: 160px !important;
  }

  .form-input .ivu-input {
    height: 20px !important;
  }
}
.address-modal {
  .ivu-form-item:before {
    display: inline-block;
    float: left;
    margin-top: 8px;
    height: 18px;
    width: 10px;
  }
  .must:before {
    content: "*";
    color: red;
  }
  .ivu-form-item .ivu-form-item-label {
    width: 40px !important;
    color: #404040;
  }
  .ivu-form-item-content {
    margin-left: 40px !important;
    label {
      padding-left: 20px !important;
      color: #bbb;
    }
  }
  .ivu-modal-footer {
    text-align: center;
  }
  .ivu-btn-long {
    width: auto;
    color: #404040;
    background-color: #f7f7f7;
    border-color: #dddee1;
  }
  .ivu-btn-error:hover {
    background-color: #3280bf;
    border-color: #3280bf;
  }
  .ivu-btn-error:focus {
    box-shadow: none;
  }
}
</style>




// WEBPACK FOOTER //
// addressModal.vue?99a160f0